import { useRef } from 'react';
import { ParameterDto } from '@/Domain/api/Action/dto/Action.dto';

const EMPTY_PARAMETERS: ParameterDto[] = [];

export const useStableParameters = (parameters: ParameterDto[] | undefined) => {
  const current = parameters ?? EMPTY_PARAMETERS;
  const signature = JSON.stringify(
    current.map(({ id, name, description, type, default_value, is_required }) => [
      id,
      name,
      description,
      type,
      default_value,
      is_required,
    ]),
  );
  const ref = useRef<{ signature: string; parameters: ParameterDto[] } | null>(null);

  if (ref.current?.signature !== signature) {
    ref.current = { signature, parameters: [...current] };
  }

  return ref.current.parameters;
};
